import _memoize from 'lodash/memoize';
import { HD, FULL_HD, safetyMargins } from '@bedrock-rdk/constants';
import { getHeight as getBlockHeaderHeight } from './blockHeader/blockHeader.style';
import { cacheResolver, makeDefaultStylingContext } from '../../../utils/style';

export const defaultContext = makeDefaultStylingContext();

export const HEADER_MARGIN_BOTTOM = {
  [HD]: 12,
  [FULL_HD]: 16,
};

export const RIGHT_PADDING = {
  [HD]: safetyMargins.horizontal.HD,
  [FULL_HD]: safetyMargins.horizontal.FULL_HD,
};

export const getTopBlockHeight = ({ screenSize } = defaultContext) =>
  getBlockHeaderHeight(screenSize) + HEADER_MARGIN_BOTTOM[screenSize];

export const getInitialStyle = _memoize(
  (context = defaultContext) => ({
    Tabs: {
      rightPadding: safetyMargins.horizontal[context.screenSize],
    },
    Content: {
      y: getTopBlockHeight(context),
    },
  }),
  cacheResolver,
);
